// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e92d4fc1","455":"bdc7ef90","488":"fc18631a","823":"f766fc50","977":"483bad32"}[chunkId] + ".chunk.js";
};